import CommandCenter from 'components/Dashboard/CommandCenter';
import LastDayWorkingSummary from 'components/Dashboard/LastDayWorkingSummary';
import DailyPickSummary from 'components/Dashboard/DailyPickSummary';
import DailyAgroSummary from 'components/Dashboard/DailyAgroSummary';
import DailyPackingSummary from 'components/Dashboard/DailyPackingSummary';
import CropsAnalytics from 'components/Dashboard/CropsAnalytics';

import Settings from 'components/Management/Settings';
import WorkersManagement from 'components/Management/Workers';
import FarmingBlock from 'components/Management/FarmingBlock';
import Activities from 'components/Management/Activities';
import Devices from 'components/Management/Devices';
import Workdays from 'components/Management/Workdays';
import Stickers from 'components/Management/Stickers';
import Users from 'components/Management/Users';
import Crops from 'components/Management/Crops';

export default {
  // dashboard routes
  'command-center': CommandCenter,
  'last-working-day-summary': LastDayWorkingSummary,
  'daily-pick-summary': DailyPickSummary,
  'daily-agro-summary': DailyAgroSummary,
  'daily-packing-summary': DailyPackingSummary,
  cropsAnalytics: CropsAnalytics,

  // management routes
  settings: Settings,
  workers: WorkersManagement,
  'farming-block': FarmingBlock,
  activities: Activities,
  devices: Devices,
  workday: Workdays,
  stickers: Stickers,
  users: Users,
  crops: Crops
};
